<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/perfil"> Cadastro/Acesso/Perfis </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="4">
            <v-text-field
              label="Perfil *"
              v-model="nome"
              :counter="200"
              :rules="[(v) => !!v || 'O Perfil é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="8">
            <v-autocomplete
              v-model="permissaoSelected"
              :items="filteredPermissao"
              label="Permissão *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              
              :rules="[(v) => !!v || 'A Permissão é obrigatória']"
              required
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Descrição"
              v-model="descricao"
              :counter="200"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isReqRolls">
          <v-col>
            <v-data-table
              :headers="headers"
              hide-default-footer
              :items="subRegra"
            >
              <template v-slot:item.acao="{ item }">
                <v-checkbox v-model="item.acao"></v-checkbox>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/perfil" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { enviarPerfilAsync } from "../../../services/perfilService";
import { mapState } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";
import { possuiModuloComAcoesDePerfil } from "../../../utils/perfilActions";

export default {
  name: "criarPerfil",
  data: () => ({
    overlay: false,
    valid: true,
    nome: null,
    descricao: null,
    expandReq: false,
    permissaoSelected: null,
    headers: [
      { text: "Regra", value: "regra", sortable: false },
      { text: "Ação", value: "acao", sortable: false },
    ],
    subRegra: [
      {
        regra: "Aprovar",
        acao: false,
      },
      {
        regra: "Declinar",
        acao: false,
      },
      {
        regra: "Inativar",
        acao: false,
      },
      {
        regra: "Realizar baixa",
        acao: false,
      },
    ],
  }),
  computed: {
    ...mapState("permissao", ["permissoesRegras"]),
    filteredPermissao() {
      return this.permissoesRegras.filter((p) => {
        return p.ativo === true;
      });
    },
    isReqRolls() {
      return possuiModuloComAcoesDePerfil(this.permissaoSelected);
    },
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarPerfilAsync(
          this.nome,
          this.descricao,
          this.permissaoSelected.id,
          this.subRegra[0].acao,
          this.subRegra[1].acao,
          this.subRegra[2].acao,
          this.subRegra[3].acao
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/perfil");
        }
      }
    },
  },
  components: {
    TabNavegacao,
  },
};
</script>